<template>
  <div>
    <template v-if="current_user.role === 'admin' && $route.path != '/type'">
      <div class="range-values mt-0">{{ toggleTitle || "Selected" }} Date:</div>
      <div class="range-slider" id="range-slider">
        <input
          type="range"
          :min="rangeValue.min"
          :max="rangeValue.max"
          v-model.number="rangeValue.minValue"
          @input="handleMinInput"
        />
        <input
          type="range"
          :min="rangeValue.min"
          :max="rangeValue.max"
          v-model.number="rangeValue.maxValue"
          @input="handleMaxInput"
        />
        <div v-if="enableRange" class="mt-3">
          <div>
            Start Date: {{ startDate.date }}
            <span class="font-weight-bold">{{ startDate.quarter }}</span>
          </div>
          <div>
            End Date: {{ endDate.date }}
            <span class="font-weight-bold">{{ endDate.quarter }}</span>
          </div>
        </div>
        <b-form-checkbox
          @change="$emit('switchRangeValue', toggleTitle)"
          name="check-button"
          switch
          class="mt-3"
        >
          {{ enableRange ? "Disable" : "Enable" }}
          {{ toggleTitle || "Selected" }}
          Date Filter
        </b-form-checkbox>
      </div>
    </template>
    <template v-else>
      <div v-show="enableRange" class="font-weight-bold">
        {{ toggleTitle || "Selected" }} Date:
        <span v-if="dateSelected.length > 0">Last {{ dateSelected }} Days</span>
      </div>
      <b-form-input
        id="range"
        @input="$emit('update:dateSelected', $event)"
        type="range"
        min="30"
        :max="maxDate ? maxDate : '360'"
        step="30"
        :disabled="!enableRange"
      ></b-form-input>
      <b-form-checkbox
        @change="$emit('switchRangeValue', toggleTitle)"
        name="check-button"
        :checked="enableRange"
        switch
      >
        {{ enableRange ? "Disable" : "Enable" }} {{ toggleTitle || "Selected" }}
        Date Filter
      </b-form-checkbox>
    </template>
  </div>
</template>

<script>
import { useUserStore } from "../../store/UserStore";
import { mapState } from "pinia";

export default {
  name: "RpdDoubleSlider",
  props: {
    rangeValue: {
      type: Object,
      required: true,
      // UPDATE 1: Change defaults to match the 'max' (far right)
      default: () => ({
        min: 0,
        max: 100,
        minValue: 0, // Set to 100 to start at far right
        maxValue: 100, // Set to 100 to start at far right
        startDate: null,
        endDate: null,
      }),
    },
    enableRange: {
      type: Boolean,
      default: false,
    },
    toggleTitle: {
      type: String,
      default: "Selected",
    },
    dateSelected: {
      type: String,
      default: "",
    },
    isMarketRental: {
      type: Boolean,
      default: false,
    },
    maxDate: null,
    mlsStartDate: null,
    mlsEndDate: null
  },
  computed: {
    ...mapState(useUserStore, ["current_user"]),
  },
  data() {
    return {
      endDate: {
        date: null,
        quarter: null,
      },
      startDate: {
        date: null,
        quarter: null,
      },
    };
  },
  mounted() {
    // UPDATE 2: Force the slider handles to the far right on load
    // We check if rangeValue exists, then set current values to the max limit
    this.handleMinInput();
    this.handleMaxInput();
  },
  methods: {
    getQuarter(dateInput) {
      const date = new Date(dateInput);
      if (isNaN(date)) return null; // Invalid date

      const month = date.getMonth();
      const year = date.getFullYear();
      const quarter = Math.floor(month / 3) + 1;

      return `Q${quarter} ${year}`;
    },
    handleMinInput() {
      if (this.rangeValue.minValue > this.rangeValue.maxValue) {
        this.rangeValue.minValue = this.rangeValue.maxValue;
      }
      const daysAgo = this.rangeValue.max - this.rangeValue.minValue;
      const today = new Date();
      const pastDate = new Date();
      pastDate.setDate(today.getDate() - daysAgo);
      this.startDate = {
        date: pastDate.toISOString().split("T")[0],
        quarter: this.getQuarter(pastDate.toISOString().split("T")[0]),
      };
      // Note: Kept your existing logic for MLS start date
      this.rangeValue.startDate = this.mlsStartDate != null ? new Date(this.mlsStartDate * 1000) : new Date(today);
    },
    handleMaxInput() {
      if (this.rangeValue.maxValue < this.rangeValue.minValue) {
        this.rangeValue.maxValue = this.rangeValue.minValue;
      }
      const daysAgo = this.rangeValue.max - this.rangeValue.maxValue;
      const today = new Date();
      const pastDate = new Date();
      pastDate.setDate(today.getDate() - daysAgo);
      this.endDate = {
        date: pastDate.toISOString().split("T")[0],
        quarter: this.getQuarter(pastDate.toISOString().split("T")[0]),
      };
      this.rangeValue.endDate = this.endDate.date;
    },
  },
};
</script>

<style scoped>
#range-slider {
  border-top: 8px solid #dee2e6;
}
.range-slider {
  position: relative;
  width: 100%;
  margin: 10px 0;
}

/* Two sliders stacked */
.range-slider input[type="range"] {
  -webkit-appearance: none;
  position: absolute;
  width: 100%;
  height: 8px;
  top: -8px;
  background: transparent;
  pointer-events: none;
  margin: 0;
  padding: 0;
}

/* Make thumbs clickable separately */
.range-slider input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  pointer-events: auto;
  width: 17px;
  height: 16px;
  border-radius: 50%;
  background: #007bff;
  cursor: pointer;
  border: none;
  position: relative;
  z-index: 10;
}

.range-slider input[type="range"]:first-child::-webkit-slider-thumb {
  z-index: 11;
}

.range-slider input[type="range"]::-moz-range-thumb {
  pointer-events: auto;
  width: 17px;
  height: 16px;
  border-radius: 50%;
  background: #007bff;
  cursor: pointer;
  border: none;
  position: relative;
  z-index: 10;
}

.range-values {
  margin-top: 30px;
  font-weight: bold;
}
</style>
